import svg from './row-svg/fleur.svg';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function FleurIcon(props: FixMe) {
  return <img {...props} src={svg} alt="svg" />;
}

export default FleurIcon;
